import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// ============================================================
// Example Component
// ============================================================
// Calendar
const Calendar = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Calendar/Calendar.vue");
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Charts.vue");

// Components pages
const Buttons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Buttons.vue");
const Cards = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Cards.vue");
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/GridSystem.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Notifications.vue"
  );
const Icons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Icons.vue");
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Typography.vue"
  );

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
const AlternativeDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
  );
const Widgets = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Widgets.vue");

// Forms pages
const FormElements = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormElements.vue");
const FormComponents = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormComponents.vue");
const FormValidation = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormValidation.vue");

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/GoogleMaps.vue");
const VectorMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/VectorMaps.vue");

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/RegularTables.vue");
const SortableTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/SortableTables.vue");
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/PaginatedTables.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Home = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Lock.vue");

const ProfileChangePassword = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/ChangePassword.vue");

const ProfileChangeProfile = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Dtac/ChangeProfile.vue");

const ForgotPassword = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/ForgotPassword.vue");
const ResetPassword = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/ResetPassword.vue");


let profileMenu = {
  path: "/profile",
  component: DashboardLayout,
  redirect: "/profile/me",
  name: "profile`",
  meta: {
    breadcrumb: "profile.info"
  },
  children: [
    {
      path: "me",
      name: "ProfileChange",
      component: ProfileChangeProfile,
      meta: {
        breadcrumb: "profile.info",
        requiresAuth: true
      }
    },
    {
      path: "changepasword",
      name: "ProfileChangePassword",
      component: ProfileChangePassword,
      meta: {
        breadcrumb: "profile.change_password",
        requiresAuth: true
      }
    }
  ]
};

// let componentsMenu = {
//   path: "/components",
//   component: DashboardLayout,
//   redirect: "/components/buttons",
//   name: "Components",
//   children: [
//     {
//       path: "buttons",
//       name: "Buttons",
//       component: Buttons
//     },
//     {
//       path: "cards",
//       name: "Cards",
//       component: Cards
//     },
//     {
//       path: "grid-system",
//       name: "Grid System",
//       component: GridSystem
//     },
//     {
//       path: "notifications",
//       name: "Notifications",
//       component: Notifications
//     },
//     {
//       path: "icons",
//       name: "Icons",
//       component: Icons
//     },
//     {
//       path: "typography",
//       name: "Typography",
//       component: Typography
//     }
//   ]
// };
// let formsMenu = {
//   path: "/forms",
//   component: DashboardLayout,
//   redirect: "/forms/elements",
//   name: "Forms",
//   children: [
//     {
//       path: "elements",
//       name: "Form elements",
//       component: FormElements
//     },
//     {
//       path: "components",
//       name: "Form components",
//       component: FormComponents
//     },
//     {
//       path: "validation",
//       name: "Form validation",
//       component: FormValidation
//     }
//   ]
// };

// let tablesMenu = {
//   path: "/tables",
//   component: DashboardLayout,
//   redirect: "/table/regular",
//   name: "Tables menu",
//   children: [
//     {
//       path: "regular",
//       name: "Tables",
//       component: RegularTables
//     },
//     {
//       path: "sortable",
//       name: "Sortable",
//       component: SortableTables
//     },
//     {
//       path: "paginated",
//       name: "Paginated Tables",
//       component: PaginatedTables
//     }
//   ]
// };

// let mapsMenu = {
//   path: "/maps",
//   component: DashboardLayout,
//   name: "Maps",
//   redirect: "/maps/google",
//   children: [
//     {
//       path: "google",
//       name: "Google Maps",
//       component: GoogleMaps
//     },
//     {
//       path: "vector",
//       name: "Vector Map",
//       component: VectorMaps
//     }
//   ]
// };

// let pagesMenu = {
//   path: "/pages",
//   component: DashboardLayout,
//   name: "Pages",
//   redirect: "/pages/user",
//   children: [
//     {
//       path: "user",
//       name: "User Page",
//       component: User
//     },
//     {
//       path: "timeline",
//       name: "Timeline Page",
//       component: TimeLine
//     }
//   ]
// };



let authPages = {
  path: "/",
  component: AuthLayout,
  redirect: "/lmg",
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/forgotpassword",
      name: "forgot_password",
      component: ForgotPassword,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/resetpassword",
      name: "reset_password",
      component: ResetPassword,
      meta: {
        noBodyBackground: true
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    },

  ]
};

const bankList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/BankTables.vue");
const billigList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/BillingTables.vue");
const invoiceList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/InvoiceTables.vue");
const branchList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/BranchTables.vue");
const commList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/CommTables.vue");
  const commExtraList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/CommExtraTables.vue");
const insureList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/InsureTables.vue");
const paymentList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/PaymentTables.vue");

const billingReportList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/BillingReportTables.vue");
const billingReportDetailList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/BillingReportDetailTables.vue");

// const paymentClearList = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/PaymentClearTables.vue");
// const paymentBranchList = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/PaymentBranchTables.vue");
const personList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/PersonTables.vue");
const transactionList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/TransactionTables.vue");
const transactionView = () =>
  import(/* webpackChunkName: "transaction-view" */ "@/views/Lmg/TransactionView.vue");
const transactionCancel = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/TransactionCancelTables.vue");
const transactionV2List = () =>
  import(/* webpackChunkName: "v2-transaction" */ "@/views/Lmg/v2/TransactionTables.vue");
const transactionV2Form = () =>
  import(/* webpackChunkName: "v2-transaction" */ "@/views/Lmg/v2/TransactionForm.vue");
const ttypeList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/TtypeTables.vue");
const userList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/UserTables.vue");
const customerList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/CustomerTables.vue");
const cashclearList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/CashClearTables.vue");
const whtList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/WhtTables.vue");
const financeList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/FinanceTables.vue");
const quickPaymentList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/QuickPaymentTables.vue");
const promptPayList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/PromptPayTables.vue");
const dmsList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/DmsBatchTables.vue");
const branchMoneyList = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Lmg/BranchMoneyTables.vue");
const invoiceV2List = () =>
  import(/* webpackChunkName: "v2-invoice" */ "@/views/Lmg/v2/InvoiceTables.vue");
const insureCatalogV2 = () =>
  import(/* webpackChunkName: "v2-insurance" */ "@/views/Lmg/v2/InsuranceCatalogV2.vue");


  // Form
// const bankForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/BankForm.vue");
// const billigForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/BillingForm.vue");
// const branchForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/BranchForm.vue");
// const commForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/CommForm.vue");
// const insureForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/InsureForm.vue");
// const paymentForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/PaymentForm.vue");
// const paymentClearForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/PaymentClearForm.vue");
// const paymentBranchForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/PaymentBranchForm.vue");
// const personForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/PersonForm.vue");
// const transactionForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/TransactionForm.vue");
// const ttypeForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/TtypeForm.vue");
// const userForm = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Lmg/UserForm.vue");

let lmgMenu = {
  path: "/lmg",
  component: DashboardLayout,
  redirect: "/lmg/v2/transaction",
  name: "lmg",
  meta: {
    breadcrumb: "lmg"
  },
  children: [
	{
	path: "wht",
      name: "WhtList",
      component: whtList,
      meta: {
        breadcrumb: "wht.list",
        requiresAuth: true
      }
	
	},
    {
      path: "bank",
      name: "BankList",
      component: bankList,
      meta: {
        breadcrumb: "bank.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "bank/form",
    //   name: "BankForm",
    //   component: bankForm,
    //   meta: {
    //     breadcrumb: "bank.form",
    //     requiresAuth: true
    //   }
    // },

    // Billing
    {
      path: "billing",
      name: "BillingList",
      component: billigList,
      meta: {
        breadcrumb: "bank.list",
        requiresAuth: true
      }
    },

	{
		path: "billingreport",
		name: "BillingReportList",
		component: billingReportList,
		meta: {
		  breadcrumb: "billing.report_list",
		  requiresAuth: true
		}
	  },
	  {
		path: "billingreport/detail",
		name: "billingreportDetailList",
		component: billingReportDetailList,
		meta: {
		  breadcrumb: "billing.report_detail_list",
		  requiresAuth: true
		}
	  },

	{
		// Retired: v1 invoice list redirects to the Calm v2 page (Phase 6c).
		// Component kept (import stays referenced) but redirect takes precedence.
		path: "invoice",
		name: "InvoiceList",
		redirect: "/lmg/v2/invoice",
		component: invoiceList,
		meta: {
		  breadcrumb: "bank.list",
		  requiresAuth: true
		}
	  },
	{
		path: "finance",
		name: "FinanceList",
		component: financeList,
		meta: {
		  breadcrumb: "finance.list",
		  requiresAuth: true
		}
	  },
	{
		path: "quick-payment",
		name: "QuickPaymentList",
		component: quickPaymentList,
		meta: {
		  breadcrumb: "quick_payment.list",
		  requiresAuth: true
		}
	  },
	{
		path: "dms",
		name: "DmsBatchList",
		component: dmsList,
		meta: {
		  breadcrumb: "dms.list",
		  requiresAuth: true
		}
	  },
	{
		path: "branch-money",
		name: "BranchMoneyList",
		component: branchMoneyList,
		meta: {
		  breadcrumb: "branch_money.list",
		  requiresAuth: true
		}
	  },
	{
		// Retired (issue #10): PromptPay is now consolidated into the Bank page.
		// Redirect to /lmg/bank. Component import kept referenced but redirect
		// takes precedence (mirrors Phase-6c v1 retirements).
		path: "promptpay",
		name: "PromptPayList",
		redirect: "/lmg/bank",
		component: promptPayList,
		meta: {
		  breadcrumb: "bank.list",
		  requiresAuth: true
		}
	  },
	{
		path: "v2/invoice",
		name: "InvoiceV2List",
		component: invoiceV2List,
		meta: {
		  breadcrumb: "invoice.v2",
		  requiresAuth: true
		}
	  },
    // {
    //   path: "billing/form",
    //   name: "BillingForm",
    //   component: billigForm,
    //   meta: {
    //     breadcrumb: "bank.form",
    //     requiresAuth: true
    //   }
    // },

    // Branch
    {
      path: "branch",
      name: "BranchList",
      component: branchList,
      meta: {
        breadcrumb: "branch.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "branch/form",
    //   name: "BranchForm",
    //   component: branchForm,
    //   meta: {
    //     breadcrumb: "branch.form",
    //     requiresAuth: true
    //   }
    // },

    // Comm
    {
      path: "commission",
      name: "CommList",
      component: commList,
      meta: {
        breadcrumb: "comm.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "commission/extra",
    //   name: "CommExtraList",
    //   component: commExtraList,
    //   meta: {
    //     breadcrumb: "commextra.list",
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: "commission/form",
    //   name: "CommForm",
    //   component: commForm,
    //   meta: {
    //     breadcrumb: "comm.form",
    //     requiresAuth: true
    //   }
    // },

    // Insure
    {
      path: "insurance",
      name: "InsureList",
      component: insureList,
      meta: {
        breadcrumb: "insure.list",
        requiresAuth: true
      }
    },
    // Insurance Catalog V2 (Calm tree page; V1 kept above for rollback)
    {
      path: "insurance-v2",
      name: "InsureCatalogV2",
      component: insureCatalogV2,
      meta: {
        breadcrumb: "insure.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "insurance/form",
    //   name: "InsureForm",
    //   component: insureForm,
    //   meta: {
    //     breadcrumb: "insure.form",
    //     requiresAuth: true
    //   }
    // },
    // Payment
    {
      path: "payment",
      name: "PaymentList",
      component: paymentList,
      meta: {
        breadcrumb: "payment.list",
        requiresAuth: true
      }
    },

	
    // {
    //   path: "payment/form",
    //   name: "PaymentForm",
    //   component: paymentForm,
    //   meta: {
    //     breadcrumb: "payment.form",
    //     requiresAuth: true
    //   }
    // },
    // Payment Clear
    // {
    //   path: "payment/clear",
    //   name: "PaymentClearList",
    //   component: paymentClearList,
    //   meta: {
    //     breadcrumb: "paymentclear.list",
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: "payment/clear/form",
    //   name: "PaymentClearForm",
    //   component: paymentClearForm,
    //   meta: {
    //     breadcrumb: "paymentclear.form",
    //     requiresAuth: true
    //   }
    // },


    // Payment Branch
    // {
    //   path: "payment/branch",
    //   name: "PaymentBranchList",
    //   component: paymentBranchList,
    //   meta: {
    //     breadcrumb: "paymentbranch.list",
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: "payment/branch/form",
    //   name: "PaymentBranchForm",
    //   component: paymentBranchForm,
    //   meta: {
    //     breadcrumb: "paymentbranch.form",
    //     requiresAuth: true
    //   }
    // },


    // Person
    {
      path: "person",
      name: "PersonList",
      component: personList,
      meta: {
        breadcrumb: "person.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "person/form",
    //   name: "PersonForm",
    //   component: personForm,
    //   meta: {
    //     breadcrumb: "person.form",
    //     requiresAuth: true
    //   }
    // },
    // Transaction
	
    {
      // Retired: v1 transaction list redirects to the Calm v2 page (Phase 6c).
      // Component kept (import stays referenced) but redirect takes precedence.
      path: "transaction",
      name: "TransList",
      redirect: "/lmg/v2/transaction",
      component: transactionList,
      meta: {
        breadcrumb: "trans.list",
        requiresAuth: true
      }
    },
    {
      path: "transaction/view/:id",
      name: "TransView",
      component: transactionView,
      meta: {
        breadcrumb: "trans.view",
        requiresAuth: true
      }
    },
    {
      path: "transaction/cancel",
      name: "TransCancel",
      component: transactionCancel,
      meta: {
        breadcrumb: "trans.cancel",
        requiresAuth: true
      }
    },
    // Transaction V2 (URL-only during build-out; no sidebar entry yet)
    {
      path: "v2/transaction",
      name: "TransV2List",
      component: transactionV2List,
      meta: {
        breadcrumb: "trans.list",
        requiresAuth: true
      }
    },
    {
      path: "v2/transaction/new",
      name: "TransV2New",
      component: transactionV2Form,
      meta: {
        breadcrumb: "trans.list",
        requiresAuth: true
      }
    },
    {
      path: "v2/transaction/:id",
      name: "TransV2Edit",
      component: transactionV2Form,
      meta: {
        breadcrumb: "trans.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "transaction/form",
    //   name: "TransForm",
    //   component: transForm,
    //   meta: {
    //     breadcrumb: "trans.form",
    //     requiresAuth: true
    //   }
    // },

    // Ttype
    {
      path: "transactiontype",
      name: "TtypeList",
      component: ttypeList,
      meta: {
        breadcrumb: "ttype.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "transactiontype/form",
    //   name: "TtypeForm",
    //   component: ttypeForm,
    //   meta: {
    //     breadcrumb: "ttype.form",
    //     requiresAuth: true
    //   }
    // },
    // User
    {
      path: "user",
      name: "UserList",
      component: userList,
      meta: {
        breadcrumb: "user.list",
        requiresAuth: true
      }
    },
    {
      path: "customer",
      name: "CustomerList",
      component: customerList,
      meta: {
        breadcrumb: "customer.list",
        requiresAuth: true
      }
    },
    {
      path: "cashclear",
      name: "CashClearList",
      component: cashclearList,
      meta: {
        breadcrumb: "cashclear.list",
        requiresAuth: true
      }
    },
    // {
    //   path: "user/form",
    //   name: "TtypeForm",
    //   component: ttypeForm,
    //   meta: {
    //     breadcrumb: "ttype.form",
    //     requiresAuth: true
    //   }
    // },

  ]
};
const routes = [
  // stockMenu,
  authPages,
  profileMenu,
  lmgMenu,
    { path: "*", component: NotFound }
];

export default routes;
